import { defineStore } from 'pinia';
import { getTeamBenefitCodes } from '@/request/user';
export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      teamBenefitCodes: [],
    };
  },
  getters: {},
  actions: {
    async getTeamBenefitCodesFn() {
      try {
        const res = await getTeamBenefitCodes({});
        if (res.data && res.data.data) {
          this.teamBenefitCodes = res.data.data;
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        console.error('Failed to fetch team benefit codes:', error);
      } finally {
      }
    },
  },
});
